(ns frontend.view.reports.custom.alj-2.active-deals-per-deadline-to-close-drilldown-table
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.reports.custom.alj-2.alj-components :as alj-components]
   [frontend.view.reports.custom.alj-2.utils :as alj-utils]))

(defn resolve-row-data
  [oppo]
  (let [oppo-id (:db/id oppo)
        bus (->> (:oppo/group-business-units oppo-id)
                 (map session/get-entity))
        stage (session/get-entity (:oppo/stage oppo))
        deal-types (->> (:oppo/tag-deal-type oppo-id)
                        (map session/get-entity))
        bu-lead (session/get-entity (:oppo/bu-lead oppo))]
    [[:a.link-green
      {:href     "#"
       :on-click (fn [e]
                   (routing/open-entity (:db/id oppo))
                   (.preventDefault e)
                   (.stopPropagation e))}
      (fu/resolve-name oppo)]
     (->> bus
          (map fu/resolve-name)
          (string/join "; "))
     (fu/resolve-name stage)
     (->> deal-types
          (map fu/resolve-name)
          (string/join "; "))
     (fu/resolve-name bu-lead)
     (fu/display-date-timestamp (:oppo/datetime-alj-deadline-to-close-deal oppo))
     (cu/truncate 200 (:oppo/status-and-next-steps oppo))]))

(defn report
  [{:keys [state reports-state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{:entity.type/oppo} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [{:keys [label oppo-ids]} (:deadline-drilldown @reports-state)

            oppos (->> (map session/get-entity oppo-ids)
                       (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo))

            row-datas (->> oppos
                           (map resolve-row-data)
                           (doall))

            ; override for now
            label ""

            view-name (str (loc/tr :oppo/datetime-alj-deadline-to-close-deal) #_" - " label)]
        [alj-components/alj-card
         {:view-name       view-name
          :report-data     row-datas
          :date-state-atom date-state-atom
          :view            [:table.alj-report.zap-simple-table
                            [:thead
                             [:tr
                              [:th (loc/tr :oppo/name)]
                              [:th "SBU"]
                              [:th (loc/tr :oppo/stage)]
                              [:th (loc/tr :oppo/tag-deal-type)]
                              [:th (loc/tr :oppo/bu-lead)]
                              [:th (loc/tr :oppo/datetime-alj-deadline-to-close-deal)]
                              [:th (loc/tr :oppo/status-and-next-steps)]]]
                            [:tbody
                             (->> row-datas
                                  (map-indexed (fn [idx row-data]
                                                 ^{:key (str "alj-2-deadline-to-close-deal-" idx)}
                                                 [:tr
                                                  {:class-name "alj-data-row"}
                                                  (->> row-data
                                                       (map-indexed (fn [cell-idx cell-data]
                                                                      (let [no-data? (or (not cell-data)
                                                                                         (and (string? cell-data)
                                                                                              (string/blank? cell-data)))]
                                                                        ^{:key (str "alj-2-deadline-to-close-deal-" idx "-" cell-idx)}
                                                                        [:td
                                                                         {:class-name (fu/cs ""
                                                                                             (when no-data?
                                                                                               "center"))}
                                                                         (cond no-data?
                                                                               "-"
                                                                               (number? cell-data)
                                                                               (str cell-data)
                                                                               :else
                                                                               cell-data)])))
                                                       (doall))]))
                                  (doall))]]}]))))
